import { Injectable } from '@angular/core';
import { DPSitePage } from '../models/enums/DPSitePage';

/**
 * API URL resolver service.
 *
 * Please refer to: https://driverportalapi.leetrans.com/swagger/index.html
 */
@Injectable({
  providedIn: 'root',
})
export class ApiUrlService {
  constructor() {}

  public company(domain: string) {
    return `/Company/${domain}`;
  }

  public companyCustomText() {
    return `/CustomText`;
  }

  public userForms() {
    return '/UserForms';
  }

  public userForm(userFormID: number) {
    return `/Form/UserForm/${userFormID}`;
  }

  public userFormDetails(userFormID: number) {
    return `/Form/Electronic/UserForm/${userFormID}`;
  }

  public jobForms(jobID: number) {
    return `/Form/Job/${jobID}`;
  }

  public allJobs(companySettingId: number) {
    return `/Job/Company/${companySettingId}`;
  }

  public job(jobID: number) {
    return `/Job/${jobID}`;
  }

  public formUserJob(formID: number, userJobID: number) {
    return `/Form/${formID}/UserJob/${userJobID}`;
  }

  public formTask(formID: number, taskID: number) {
    return `/Form/${formID}/Tasks/${taskID}`;
  }

  public userJob(userJobID: number) {
    return `/Job/UserJob/${userJobID}`;
  }

  public uploadTaskFiles(taskId: number) {
    return `/Compliance/Tasks/${taskId}`;
  }

  public signature() {
    return `/Signature`;
  }

  public userFormPDF(userFormID: number) {
    return `/Form/PDF/UserForm/${userFormID}`;
  }

  public userJobPDF(userJobID: number) {
    return `/Form/PDF/UserJob/${userJobID}`;
  }

  public uploadImages(userJobID: number, imageType: number) {
    return `/Job/UserJob/${userJobID}/Upload/${imageType}`;
  }

  public locationTree(jobID: number) {
    return `/Job/${jobID}/LocationTree`;
  }

  public userFormSignature(userFormID: number) {
    return `/Signature/UserForm/${userFormID}`;
  }

  public compliance(driverID: number) {
    return `/Compliance/Driver/${driverID}`;
  }

  public user(userID: string) {
    return `/User/${userID}`;
  }

  public avatar() {
    return '/User/Avatar';
  }

  public feedback() {
    return '/User/Feedback';
  }

  public uploadTask(imageTypeId: number, driverID: number) {
    return `/Compliance/Tasks/${imageTypeId}/Driver/${driverID}`;
  }

  public deleteUserCreatedTask(taskId: number) {
    return `/Compliance/Tasks/${taskId}`;
  }

  public currentApplication() {
    return '/Application'
  }

  public currentApplicationSettings() {
    return '/Application/Settings'
  }

  public currentApplicationDependencies() {
    return '/Application/FormDependencies';
  }

  public currentApplicationAddendum(taskId: number, formId: number) {
    return `/Application/Addendum?taskId=${taskId}&formId=${formId}`;
  }

  public currentApplicationSignature(userFormID: number) {
    return `/Signature/UserForm/${userFormID}/Application`;
  }
}
